import React from 'react';

import {
    FormInput,
} from 'wanderu-component-form';
import {
    Button,
} from 'wanderu-components';

import styles from './ButtonTextField.scss';

function ButtonTextField(props) {
    const {
        buttonText,
        disabled,
        onClick,
        value,
        copyToClipboard = false,
        ...otherProps
    } = props;

    const _onCopyClick = (e) => {
        const textField = document.createElement('textarea');
        textField.innerText = value;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();
        onClick(e);
    };

    return (
        <div className={styles.buttonTextFieldContainer}>
            <FormInput
                className={styles.form}
                clearable={false}
                disabled={disabled}
                value={value}
                readOnly
                {...otherProps}
            />
            <Button
                className={styles.button}
                disabled={disabled}
                onClick={copyToClipboard
                    ? _onCopyClick
                    : onClick}
            >
                {buttonText}
            </Button>
        </div>
    );
}

export default ButtonTextField;
